import { render, staticRenderFns } from "./M2hComingSoon.vue?vue&type=template&id=3e2c1644&scoped=true&"
import script from "./M2hComingSoon.vue?vue&type=script&lang=js&"
export * from "./M2hComingSoon.vue?vue&type=script&lang=js&"
import style0 from "./M2hComingSoon.vue?vue&type=style&index=0&id=3e2c1644&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2c1644",
  null
  
)

export default component.exports